import { Space, Typography } from 'antd'
import { toJS } from 'mobx'
const { Title } = Typography

export const DefaultTemplate = ({ headerPageContext }) => (
    <div>
        <div className="wl-header-page--wrapper">
            <div className="wl-header-page--wrapper-left">
                {!!headerPageContext.title && (
                    <div className="wl-header-page--title">
                        {typeof toJS(headerPageContext.title) == 'string' ? (
                            <Title level={3} style={{ margin: 0 }} ellipsis={true}>
                                {headerPageContext.title}
                            </Title>
                        ) : (
                            headerPageContext.title
                        )}
                    </div>
                )}
                {headerPageContext?.titleExtra && (
                    <div className="wl-header-page--title-extra">
                        <Space>{headerPageContext.titleExtra}</Space>
                    </div>
                )}
            </div>
            <div className="wl-header-page--wrapper-right">
                {headerPageContext.extra.length > 0 && (
                    <div className="wl-header-page--extra">{headerPageContext.extra}</div>
                )}
                {headerPageContext?.afterExtra && (
                    <div className="wl-header-page--after-extra">{headerPageContext.afterExtra}</div>
                )}
            </div>
        </div>
    </div>
)
